import axios from 'axios'
import ApplicationController from '../application_controller.js'

/*
 *
 * Widget Envoi relances factures impayées
 *
 * Ce contrôleur a besoin d'une référence vers le contrôleur dashboard-widgets correspondant, pour l'appel à load()
 */

export default class Widget3Controller extends ApplicationController {

  connect() {
    //this.dashboardWidgetController = this.application.getControllerForElementAndIdentifier(document.querySelector('#dashboard .widget.droppable[data-id="widget3"]'), "dashboard--widgets")
    this.evtL1 = this.initTrix.bind(this)
    this.element.addEventListener("trix-initialize", this.evtL1, false)
  }

  disconnect() {
    this.element.removeEventListener("trix-initialize", this.evtL1, false)
  }

  initTrix(e) {
    const { toolbarElement } = e.target // Récupère la toolbar - Trix est un webcomponent, d'où la syntaxe bizarre
    e.target.style.height = '15rem' // Et ici l'éditeur
    e.target.style.overflowY = 'scroll'
    toolbarElement.querySelector(".trix-button-group--file-tools").style.display = 'none'
    toolbarElement.querySelector(".trix-button-group--block-tools").style.display = 'none'
    toolbarElement.querySelector(".trix-button--icon-link").style.display = 'none'
  }

  open_dialog(e) {
    e.preventDefault()
    axios.get(e.target.href)
      .then(response => {
        this.modal(response.data, { size: 'large' }, (reason) => {
          if (reason.confirm) {
            axios.post(reason.form.getAttribute('action'), new FormData(reason.form)).then(response => {
              reason.close_modal()
              this.notify(response.data)
              this.dashboardWidgetController.load()
            }).catch(error => {
              this.alert(error.response.data)
            })
          } else
            reason.close_modal()
        })
      })
  }

}